/* Copyright (c) 2023 Xperi. All Rights Reserved.  */

export class BrandingUiUtility {
    public static formatDescription = (description: string, replaceValues: {}) => {
        let formattedDescription = description;
        const keys = Object.keys(replaceValues);

        keys.forEach((key) => {
            const regexKey = new RegExp(`\\b${key}\\b`, 'g');
            formattedDescription = formattedDescription.replace(regexKey, replaceValues[key]);
        });
        return formattedDescription;
    };
}
